import { addDays, compareAsc, toDate } from 'date-fns';

export const createDatesArray = (minDate: Date, maxDate: Date): Date[] => {
	let date = toDate(minDate);

	const datesArray: Date[] = [];

	datesArray.push(minDate);

	while (compareAsc(maxDate, date) === 1) {
		date = addDays(date, 1);

		datesArray.push(date);
	}

	return datesArray;
};
